var util = require('../util');
function positionNode(node, previousNode, indent, dropCap, align) {
  //  caculate the node's horizontal offset DX, dx's type might be number or function
  var displacementX = typeof indent === 'function' ? indent(node) : indent * node.depth;
  if (!dropCap) {
    try {
      if (node.id === node.parent.children[0].id) {
        node.x += displacementX;
        node.y = previousNode ? previousNode.y : 0;
        return;
      }
    } catch (e) {
      // skip to normal when a node has no parent
    }
  }
  node.x += displacementX;
  if (previousNode) {
    var _previousNode$parent;
    node.y = previousNode.y + util.getHeight(previousNode, node, align);
    if (node.parent.id !== ((_previousNode$parent = previousNode.parent) == null ? void 0 : _previousNode$parent.id)) {
      // previous node has different parent
      var index = node.parent.children.findIndex(function (n) {
        return n.id === node.id;
      });
      var preNode = node.parent.children[index - 1];
      if (preNode) {
        var preY = preNode.y + util.getHeight(preNode, node, align);
        node.y = preY > node.y ? preY : node.y;
      }
    }
  } else {
    node.y = 0;
  }
  return;
}
module.exports = function (root, indent, dropCap, align) {
  var previousNode = null;
  root.eachNode(function (node) {
    positionNode(node, previousNode, indent, dropCap, align);
    previousNode = node;
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/layout/indented.js
// module id = 123
// module chunks = 0